import { CandidatePriority } from '../candidate';
import { JobTitleEnum } from './job-titles.enum';

// We need this to show short labels for job titles in specific places
export const JOB_TITLES_WITH_SHORT_FORMS: { [jobTitle: string]: string } = {
  [JobTitleEnum.NursingSpecialistHealthCare]: 'nursing_specialist',
  [JobTitleEnum.NursingSpecialistGeriatric]: 'nursing_specialist',
};

export const THERAPIST_TRACKING_PRIORITIES = [CandidatePriority.B5, CandidatePriority.B6];
